import {
  FETCH_MATERIAL_UPDATES_START,
  FETCH_MATERIAL_UPDATES_SUCCESS,
  FETCH_MATERIAL_UPDATES_FAIL,
  FETCH_SINGLE_MATERIAL_UPDATE_START,
  FETCH_SINGLE_MATERIAL_UPDATE_SUCCESS,
  FETCH_SINGLE_MATERIAL_UPDATE_FAIL,
  CREATE_MATERIAL_UPDATE_START,
  CREATE_MATERIAL_UPDATE_SUCCESS,
  CREATE_MATERIAL_UPDATE_FAIL,
  UPDATE_MATERIAL_UPDATE_START,
  UPDATE_MATERIAL_UPDATE_SUCCESS,
  UPDATE_MATERIAL_UPDATE_FAIL,
  CLEAR_CURRENT_UPDATE,
  CLEAR_MASTER_DATA_UPDATES_CACHE,
  FETCH_MASTER_DATA_UPDATES_BY_PROFILE,
  FETCH_MASTER_DATA_UPDATES_BY_PROFILE_SUCCESS,
  FETCH_MASTER_DATA_UPDATES_BY_PROFILE_FAIL,
  SUPPLIER_DETAILS_BY_UPDATE_NO,
  SUPPLIER_DETAILS_BY_UPDATE_NO_FAIL,
  SET_MESSAGE_DIALOG_DATA,
  FETCH_CUSTOMER_MASTER_START,
  FETCH_CUSTOMER_MASTER_SUCCESS,
  FETCH_CUSTOMER_MASTER_FAIL,
  FETCH_CUSTOMER_MASTER_BY_ID_START,
  FETCH_CUSTOMER_MASTER_BY_ID_SUCCESS,
  FETCH_CUSTOMER_MASTER_BY_ID_FAIL,
  FETCH_APPROVAL_PAGE_DETAILS,
  FETCH_CUSTOMER_UPDATE_DEFAULT_PROFILE_START,
  FETCH_CUSTOMER_UPDATE_DEFAULT_PROFILE_SUCCESS,
  FETCH_CUSTOMER_UPDATE_DEFAULT_PROFILE_FAIL,
  FETCH_CUSTOMER_MASTER_GROUPED_START,
  FETCH_CUSTOMER_MASTER_GROUPED_SUCCESS,
  FETCH_CUSTOMER_MASTER_GROUPED_FAIL,
  CLEAR_FETCH_CUSTOMER_MASTER_BY_ID,
  GET_MASTER_DATA_PROFILE,
  CLEAR_MASTER_DATA_PROFILE,
  GET_MASTER_DATA_PROFILE_BY_NAME_SUCCESS,
  GET_CUSTOMER_BY_PROFILE_SUCCESS,
  CLEAR_CUSTOMER_BY_PROFILE
} from '../../actions/MasterData/ActionTypes';

const initialState = {
  loading: false,
  error: null,
  updates: [],
  currentUpdate: null,
  pagination: {
    page: 1,
    limit: 10,
    total: 0
  },
  supplierDetailsByUpdateNo: [],
  messageDialogData: [],
  customerMasterData: [],
  customerApprovalByIdData: null,
  approvalPageDetails: null,
  customerUpdateDefaultProfile: null,
  customerMasterGroupedData: [],
  masterDataProfileAllData: [],
  masterDataProfileByNameData: [],
  // Identifies which master + profile masterDataProfileByNameData holds, so the
  // action can serve it from cache instead of refetching on every page mount.
  masterDataProfileByNameKey: '',
  masterDataByProfileData: [],
};

export default function masterDataReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_MATERIAL_UPDATES_START:
    case FETCH_SINGLE_MATERIAL_UPDATE_START:
    case CREATE_MATERIAL_UPDATE_START:
    case UPDATE_MATERIAL_UPDATE_START:
    case FETCH_CUSTOMER_MASTER_START:
    case FETCH_CUSTOMER_MASTER_BY_ID_START:
    case FETCH_CUSTOMER_UPDATE_DEFAULT_PROFILE_START:
      return {
        ...state,
        loading: true,
        error: null
      };

    case FETCH_MATERIAL_UPDATES_SUCCESS:
      return {
        ...state,
        loading: false,
        updates: (action.payload.records || []).map(record => ({
          ...record,
          id: record.ID, // Map ID to id for DataGrid compatibility
          update_number: `MM-${record.ID}`, // Create an update number from ID
          update_status: record.update_status,
          material_description: record.material_description,
          material_category: record.material_category,
          profile_name: record.profile_name,
          effective_date: new Date(record.effective_date).toLocaleDateString(),
          created_by: record.created_by_id,
          updated_by: record.updated_by_id
        })),
        pagination: {
          page: action.payload.page || 1,
          limit: action.payload.limit || 10,
          total: action.payload.records?.length || 0
        }
      };

    case FETCH_SINGLE_MATERIAL_UPDATE_SUCCESS:
      console.log('action.payload', action.payload)
      return {
        ...state,
        loading: false,
        currentUpdate: action.payload
      };

    case CREATE_MATERIAL_UPDATE_SUCCESS:
      return {
        ...state,
        loading: false,
        updates: [action.payload, ...state.updates]
      };

    case UPDATE_MATERIAL_UPDATE_SUCCESS:
      return {
        ...state,
        loading: false,
        updates: state.updates.map(update =>
          update.id === action.payload.id ? action.payload : update
        ),
        currentUpdate: action.payload
      };
    case CREATE_MATERIAL_UPDATE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    case CLEAR_CURRENT_UPDATE:
      return {
        ...state,
        supplierDetailsByUpdateNo: null, // Clear the current update
        loading: false,
        error: null
      };

    case CLEAR_MASTER_DATA_UPDATES_CACHE:
      return {
        ...state,
        masterDataUpdatesByProfile: null,
        loading: false,
        error: null
      };

    case FETCH_MATERIAL_UPDATES_FAIL:
    case FETCH_SINGLE_MATERIAL_UPDATE_FAIL:
    case UPDATE_MATERIAL_UPDATE_FAIL:
      console.log('action.payload', action.payload)
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    case FETCH_MASTER_DATA_UPDATES_BY_PROFILE:
      return {
        ...state,
        loading: false,
        masterDataUpdatesByProfile: action.payload
      };
    case FETCH_MASTER_DATA_UPDATES_BY_PROFILE_SUCCESS:
      return {
        ...state,
        loading: false,
        masterDataUpdatesByProfile: action.payload
      };
    case FETCH_MASTER_DATA_UPDATES_BY_PROFILE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    case SUPPLIER_DETAILS_BY_UPDATE_NO:
      return {
        ...state,
        loading: false,
        supplierDetailsByUpdateNo: action.payload
      };
    case SUPPLIER_DETAILS_BY_UPDATE_NO_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    case SET_MESSAGE_DIALOG_DATA:
      return {
        ...state,
        messageDialogData: action.payload,
      };
    case FETCH_CUSTOMER_MASTER_SUCCESS:
      return {
        ...state,
        loading: false,
        customerMasterData: action.payload,
      };
    case FETCH_CUSTOMER_MASTER_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case FETCH_CUSTOMER_MASTER_BY_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        customerApprovalByIdData: action.payload,
      };
    case CLEAR_FETCH_CUSTOMER_MASTER_BY_ID:
      return {
        ...state,
        customerApprovalByIdData: null,
      };
    case FETCH_CUSTOMER_MASTER_BY_ID_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case FETCH_APPROVAL_PAGE_DETAILS:
      return {
        ...state,
        loading: false,
        approvalPageDetails: action.payload,
      };
    case FETCH_CUSTOMER_UPDATE_DEFAULT_PROFILE_SUCCESS:
      return {
        ...state,
        loading: false,
        customerUpdateDefaultProfile: action.payload,
      };
    case FETCH_CUSTOMER_UPDATE_DEFAULT_PROFILE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case FETCH_CUSTOMER_MASTER_GROUPED_START:
      return {
        ...state,
        loading: true,
        error: null
      };
    case FETCH_CUSTOMER_MASTER_GROUPED_SUCCESS:
      return {
        ...state,
        loading: false,
        customerMasterGroupedData: action.payload,
      };
    case FETCH_CUSTOMER_MASTER_GROUPED_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_MASTER_DATA_PROFILE:
      return {
        ...state,
        masterDataProfileAllData: [],
      };
    case GET_MASTER_DATA_PROFILE:
      return {
        ...state,
        masterDataProfileAllData: action.data,
      };
    case GET_MASTER_DATA_PROFILE_BY_NAME_SUCCESS:
      return {
        ...state,
        masterDataProfileByNameData: action.data,
        masterDataProfileByNameKey: action.key || '',
      };
    case CLEAR_CUSTOMER_BY_PROFILE:
      return {
        ...state,
        masterDataByProfileData: [],
      };
    case GET_CUSTOMER_BY_PROFILE_SUCCESS:
      return {
        ...state,
        masterDataByProfileData: action.data,
      };
    default:
      return state;
  }
}
